import styled from 'styled-components';
import * as DesignSystem from '../../../../../../assets/styles/StyleTypes';


export const Div = styled.div`
    display: flex;
    width: 100%;
    @media screen and (max-width: 700px) {
        flex-direction: column;
    }
    &.options {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Div2 = styled.div`
    display: flex;
    margin-bottom: 20px;
    margin-top: 20px;
`;

export const Name = styled.div`
    display: block;
    height: 64px;
    margin-right: 20px;
    width: 100%;
    
    @media screen and (max-width: 700px) {
        margin-right: 10px;
        min-width: 150px;
        width: 100%;
    }
`;

export const Phone = styled.div`
    display: flex;
    width: 100%;
    .ppsa-input-phone-intl-container {
        width: 100%;
    };
`;

export const Email = styled.div`
    display: block;
    width: 100%;
`;

export const Icon = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    svg{
        color: ${(props) => props.theme.colors.textTitle};
        margin-top: 18px;
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
`;


export const DivOption = styled.div`
    display: flex;
    height: auto;
    align-items: center;
    gap: 5px;

    svg{
        font-size: 18px;
        color: ${(props) => props.theme.colors.textTitle};
    }

    p {
    margin: 0px;
    text-align: left;
    letter-spacing: 0.15px;
    color: ${(props) => props.theme.colors.textTitle};
    opacity: 1;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    font-weight: bold;
    cursor: pointer;
    padding-top: 5px;
    }
`;

export const EditEmailButton = styled.button`
    align-self: flex-end;
    margin: 0 0 4px;
    padding: 6px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: ${(props) => props.theme.colors.textTitle};
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${(props) => props.theme.colors.textTitle};
        outline-offset: 2px;
    }
`;

export const ConfirmationText = styled.p`
    margin: 0;
    color: ${(props) => props.theme.colors.textTitle};
    font: 14px/1.5 Roboto, sans-serif;
`;
